export enum LiEventType {
	SEARCH = "SEARCH",
	SPECIFIC = "SPECIFIC",
	COMPANY = "COMPANY",
}
